import { PERMISSIONS, USER_ROLES, userHasPermission } from "@/utils/permissions";

export const INTERNAL_DASHBOARD_CONFIG = Object.freeze({
  [USER_ROLES.ADMIN]: {
    roleLabel: "dashboard-role-admin",
    pageTitle: "dashboard-page-admin",
    cards: [
      {
        key: "global-view",
        title: "dashboard-card-global-view-title",
        description: "dashboard-card-global-view-description",
        buttonText: "dashboard-card-global-view-button",
        actionKey: "showGlobalView",
        permission: PERMISSIONS.VIEW_USERS,
        backBg: "#3f72af",
        frontBg: "#5a8fc7",
      },
      {
        key: "teacher-applications",
        title: "dashboard-card-teacher-applications-title",
        description: "dashboard-card-teacher-applications-description",
        buttonText: "dashboard-card-teacher-applications-button",
        actionKey: "showApplicationsModal",
        permission: PERMISSIONS.MANAGE_TEACHER_APPLICATIONS,
        backBg: "#3f72af",
        frontBg: "#5a8fc7",
      },
      {
        key: "game-tracking",
        title: "dashboard-card-game-tracking-title",
        description: "dashboard-card-game-tracking-description",
        buttonText: "dashboard-card-game-tracking-button",
        actionKey: "showSessionsModal",
        permission: PERMISSIONS.VIEW_ALL_GAMES,
        backBg: "#3f72af",
        frontBg: "#5a8fc7",
      },
    ],
  },
  [USER_ROLES.TEACHER]: {
    roleLabel: "dashboard-role-teacher",
    pageTitle: "dashboard-page-teacher",
    cards: [
      {
        key: "my-games",
        title: "dashboard-card-my-games-title",
        description: "dashboard-card-my-games-description",
        buttonText: "dashboard-card-my-games-button",
        actionKey: "showMyGames",
        permission: PERMISSIONS.VIEW_OWN_GAMES,
        backBg: "#3f72af",
        frontBg: "#5a8fc7",
      },
      {
        key: "public-games",
        title: "dashboard-card-public-games-title",
        description: "dashboard-card-public-games-description",
        buttonText: "dashboard-card-public-games-button",
        actionKey: "showPublicGames",
        permission: PERMISSIONS.VIEW_PUBLIC_GAMES,
        backBg: "#2d6a4f",
        frontBg: "#40916c",
      },
      {
        key: "share-game",
        title: "dashboard-card-share-game-title",
        description: "dashboard-card-share-game-teacher-description",
        buttonText: "dashboard-card-share-game-button",
        actionKey: "goToGroups",
        permission: PERMISSIONS.MANAGE_SHARING_GROUPS,
        backBg: "#6a4c93",
        frontBg: "#8b6cb3",
        visibilityKey: "sharingGroupsAvailable",
      },
    ],
  },
  [USER_ROLES.RESEARCHER]: {
    roleLabel: "dashboard-role-researcher",
    pageTitle: "dashboard-page-researcher",
    cards: [
      {
        key: "global-view",
        title: "dashboard-card-user-review-title",
        description: "dashboard-card-user-review-description",
        buttonText: "dashboard-card-user-review-button",
        actionKey: "showGlobalView",
        permission: PERMISSIONS.VIEW_USERS,
        backBg: "#3f72af",
        frontBg: "#5a8fc7",
      },
      {
        key: "public-games",
        title: "dashboard-card-public-games-title",
        description: "dashboard-card-public-games-researcher-description",
        buttonText: "dashboard-card-public-games-button",
        actionKey: "showPublicGames",
        permission: PERMISSIONS.VIEW_PUBLIC_GAMES,
        backBg: "#2d6a4f",
        frontBg: "#40916c",
      },
      {
        key: "share-game",
        title: "dashboard-card-share-game-title",
        description: "dashboard-card-share-game-researcher-description",
        buttonText: "dashboard-card-share-game-button",
        actionKey: "goToGroups",
        permission: PERMISSIONS.MANAGE_SHARING_GROUPS,
        backBg: "#6a4c93",
        frontBg: "#8b6cb3",
        visibilityKey: "sharingGroupsAvailable",
      },
    ],
  },
});

export function getDashboardConfig(role) {
  return INTERNAL_DASHBOARD_CONFIG[role] || null;
}

export function buildDashboardCards(role, actionHandlers = {}, stateFlags = {}, user = null, roleContext = null) {
  const config = getDashboardConfig(role);
  if (!config) return [];

  return config.cards
    .map((card) => ({
      ...card,
      clickFunction: actionHandlers[card.actionKey],
      visible:
        (card.visibilityKey ? Boolean(stateFlags[card.visibilityKey]) : card.visible !== false) &&
        userHasPermission(user, card.permission, roleContext),
    }))
    .filter((card) => typeof card.clickFunction === "function");
}
